<template>
    <div class="app region-selector" v-if="visible">
        <header class="app-header">
            <cus-field style="width: 8rem; height: 100%;border-bottom: 0" wrap-background="#042D6F" type="search" placeholder="请输入需要搜索的市场" v-model="searchText"></cus-field>
            <span class="btn-cancel" @click="onCancel">取消</span>
        </header>
        <div class="app-body body-padding">
            <van-tabs class="region-tabs">
                <!--<van-tab title="全部">
                    <ul class="region-box">
                        <template v-for="subList in regionList">
                            <li class="region-box&#45;&#45;item"
                                @click="handleSelectItem(item)"
                                :class="{'region-box&#45;&#45;item__active': value.id === item.id}"
                                v-for="item in subList"
                                :key="item.id">
                                {{item.name}}
                            </li>
                        </template>
                    </ul>
                </van-tab>-->
                <van-tab :title="key" v-for="(subList, key) in regionList" :key="key">
                    <ul class="region-box">
                        <li class="region-box--item"
                            @click="handleSelectItem(item)"
                            :class="{'region-box--item__active': value.id === item.id}"
                            v-for="item in subList"
                            :key="item.id">
                            {{item.name}}
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        name: "regionSelector",
        data() {
            return {
                searchText: '',
                regionList: {},
            }
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            visible: {
                type: Boolean,
                default: false
            },
            city: {
                type: Object,
                default: () => { return {} }
            }
        },
        watch: {
            searchText() {
                this.getList()
            },
            visible(newVal) {
                if (newVal) this.getList()
            }
        },
        methods: {
            handleSelectItem(item) {
                this.$emit('input', {...item})
                this.$emit('update:visible', false)
            },
            getList() {
                let params = {
                    params: {
                        name: this.searchText,
                        provinceId: this.city.provinceId,
                        cityId: this.city.cityId,
                        districtId: this.city.districtId
                    }
                }
                this.$axios.post('merchant/getTradingRegionList', params).then((res) => {
                    if (res.data.code === 200) {
                        this.regionList = res.data.data
                    }
                })
            },
            onCancel() {
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="scss">
    .region-selector {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;

        .app-header {
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn-cancel {
                height: 100%;
                line-height: 1.17rem;
                padding: 0 0.3rem;
            }
        }

        .search-input {
            line-height: 0.93rem;
        }

        .body-padding {
            display: flex;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }

        .region-tabs {
            width: 100%;
            display: flex;
            flex-direction: column;
            flex: 1;

            .van-tabs__wrap{
                overflow: visible;
            }
        }

        .region-box {
            height: 100%;
            width: 100%;
            background-color: #fff;
            overflow-y: scroll;

            &--item {
                height: 1.17rem;
                line-height: 1.17rem;
                text-align: center;
                font-size: 0.39rem;
                border-bottom: 1px solid #e5e5e5;

                &__active {
                    background-color: #FE9329;
                    color: #ffffff;
                    border: 1px solid #FE9329 !important;
                }
            }
        }

        .van-tabs__content {
            height: 100%;
        }

        .van-tab__pane {
            height: 100%;
            padding-top: 0.08rem;
        }

        .van-tab {
            font-size: 0.37rem;
            color: #FE9329;
            min-width: 80px;
            max-width: 80px;

            &--active {
                background-color: #FE9329;
                color: #ffffff;
            }
        }

        .van-tabs__line {
            height: 0;
        }
    }
</style>
